import { SeverityLevel } from '@microsoft/applicationinsights-web';
import React, { Component } from 'react';
import { safeTrackException } from '../../appInsights';
import { ErrorPage } from './ErrorPage';

export class ErrorBoundary extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }
  componentDidCatch(error: any, errorInfo: any) {
    safeTrackException(
      error,
      {
        source: 'ErrorBoundary',
        componentStack: errorInfo?.componentStack?.slice(0, 4000),
      },
      SeverityLevel.Error
    );
  }

  render() {
    const { hasError, error } = this.state;

    if (hasError) return <ErrorPage error={error} />;
    else return this.props.children;
  }
}
